import { ICardCommercialOffersProgram } from "./types"

import { DictSelectorContainer } from "@smart/dictSelector/ui.container"

import { IconClearClose, IconSelectData } from "@img/icons"
import { Button, Divider, Flex, Input, Modal, ToolTip } from "@ui/index"

/** Анкета программы по комерческому предложению */
export const CardCommercialOffersProgram = ({
    isOpen, cardMode, fieldsError, dbName,
    txtProgramName, txtProgramNameActual, txtDocumentTypeName, txtAttestationTypeName, 
    txtDurationEducation, txtVolumeHours, txtPrice, txtListenersCount,
    
    txtDurationEducationOnChange, dictSelectorData, handleBtnSave, handleButtonCancel
}: ICardCommercialOffersProgram) => {

    /** Кнопка очистки */
    const getBtnClear = (handleBtnClick: () => void) => {
        return <>
            <ToolTip placement="left" title='Очистить'>
                <Button size="sm" variant="iconInput" onClick={handleBtnClick}><IconClearClose width='18px' height='18px' /></Button>
            </ToolTip>
        </>
    }

    /** Кнопка выбора */
    const getBtnSelect = () => {
        return <>
            <ToolTip placement="left" title='Выбрать'>
                <Button size="sm" variant="iconInput"><IconSelectData /></Button>
            </ToolTip>
        </>
    }

    return <>
        <Modal isOpen={isOpen} isEsc maxWidth="640px" className="modalMobile_content" overflowY="auto" onCancel={handleButtonCancel}>
            <Flex className='modal_container' width="100%">
                <Flex flexDirection="row" alignItems="center" justifyContent="space-between" className='modal_container-header'>
                    <h4>{cardMode === 'new' ? 'Добавление программы' : 'Редактирование программы'}</h4>

                    <Button variant='icon' size='md' onClick={handleButtonCancel}>
                        <IconClearClose />
                    </Button>
                </Flex>

                <Flex gap='4px' className='modal_container-body'>
                    <Flex gap="20px" className='modal_container-content' overflowY="auto">
                        <Flex gap="5px">
                            <Divider gap="6px" prefix={<h4>Программа</h4>} />

                            <Flex gap='10px'>
                                <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.programName ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Наименование программы <p className="pulse"></p></Flex>
                                        <Input placeholder="Наименование программы" isReadOnly paddingRight='3px' {...txtProgramName}
                                            suffix={
                                                <DictSelectorContainer dbName={dbName} dictName="coursesContract" 
                                                    onSelect={(data) => {dictSelectorData('coursesContract', data)}}
                                                >{getBtnSelect()}</DictSelectorContainer>
                                            }  
                                        />
                                    </Flex>
                                </Flex>

                                <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.programNameActual ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Наименование программы фактическое <p className="pulse"></p></Flex>
                                        <Input placeholder="Наименование программы фактическое" paddingRight='3px' {...txtProgramNameActual} 
                                            suffix={txtProgramNameActual.value && getBtnClear(txtProgramNameActual.reset)}
                                        />
                                    </Flex>
                                </Flex>
                            </Flex>
                        </Flex>

                        <Flex gap="5px">
                            <Divider gap="6px" prefix={<h4>Тип</h4>} />

                            <Flex gap='10px'>
                                <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.documentTypeName ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Тип программы <p className="pulse"></p></Flex>
                                        <Input placeholder="Тип программы" isReadOnly paddingRight='3px' {...txtDocumentTypeName}
                                            suffix={
                                                <DictSelectorContainer isSearch={false} isScroll={false}
                                                    dbName={dbName} dictName="documentTypes" 
                                                    onSelect={(data) => {dictSelectorData('documentTypes', data)}}
                                                >{getBtnSelect()}</DictSelectorContainer>
                                            }  
                                        />
                                    </Flex>
                                </Flex>

                                <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                                    <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.attestationTypeName ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Тип аттестации <p className="pulse"></p></Flex>
                                        <Input placeholder="Тип аттестации" isReadOnly paddingRight='3px' {...txtAttestationTypeName}
                                            suffix={
                                                <DictSelectorContainer isSearch={false} isScroll={false}
                                                    dbName={dbName} dictName="attestationType" 
                                                    onSelect={(data) => {dictSelectorData('attestationType', data)}}
                                                >{getBtnSelect()}</DictSelectorContainer>
                                            }  
                                        />
                                    </Flex>
                                </Flex>
                            </Flex>
                        </Flex>

                        <Flex gap="5px">
                            <Divider gap="6px" prefix={<h4>Прочее</h4>} />

                            <Flex gap='10px'>
                                <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                                    <Flex flexGrow={1} flexBasis='190px' className={!fieldsError.value.durationEducation ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Продолжительность <p className="pulse"></p></Flex>
                                        <Input placeholder="Продолжительность" paddingRight='3px'
                                            value={txtDurationEducation.value} onChange={(e) => txtDurationEducationOnChange(e.target.value)}
                                            suffix={txtDurationEducation.value && getBtnClear(txtDurationEducation.reset)}
                                        />
                                    </Flex>

                                    <Flex flexGrow={1} flexBasis='190px' className={!fieldsError.value.volumeHours ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Объём <p className="pulse"></p></Flex>
                                        <Input placeholder="Объём" paddingRight='3px' {...txtVolumeHours} 
                                            suffix={txtVolumeHours.value && getBtnClear(txtVolumeHours.reset)}
                                        />
                                    </Flex>
                                </Flex>

                                <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                                    <Flex flexGrow={1} flexBasis='190px' className={!fieldsError.value.price ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Сумма <p className="pulse"></p></Flex>
                                        <Input placeholder="Сумма" paddingRight='4px' {...txtPrice} 
                                            suffix={txtPrice.value && getBtnClear(txtPrice.reset)}
                                        />
                                    </Flex>

                                    <Flex flexGrow={1} flexBasis='190px' className={!fieldsError.value.listenersCount ? 'input_error' : 'input_error input_error-active'}>
                                        <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Кол. слушателей <p className="pulse"></p></Flex>
                                        <Input placeholder="Кол. слушателей" paddingRight='3px' {...txtListenersCount} 
                                            suffix={txtListenersCount.value && getBtnClear(txtListenersCount.reset)}
                                        />
                                    </Flex>
                                </Flex>
                            </Flex>
                        </Flex>                        
                    </Flex>

                    <Divider />

                    <Button width='100%' onClick={handleBtnSave}>
                        {cardMode === 'new' ? 'Добавить программу' : 'Применить изменения'}
                    </Button>
                </Flex>
            </Flex>
        </Modal>
    </>
}